export function shouldRejectInvite(o: { isInCall: boolean; hasIncomingCall: boolean }): boolean {
  return o.isInCall || o.hasIncomingCall;
}
